module.exports = "/static/assets/a7e482656c8708b4fbda3a76cbe2772b.png";